(function($) {
    var _generateID = function() {
        return 'badge_' + generateUUID();
    };

    $.fn.extend({
        badgeCardDetails: function(options) {
            var defaults = {
                complete: undefined
            },
            $this = $(this);
            options = $.extend(defaults, options);

        }
    });

    $.fn.extend({
        badgeCard: function(option) {
            return this.each(function() {
                var $this = $(this);
                var defaults = {
                },
                // Override defaults
                options = $.extend(defaults, option);

                // check if this has an id for aria referencing
                if( $this.attr("id") == undefined || $this.attr("id").length == 0 ) {
                    $this.attr("id",_generateID());
                }
                // Close Handlers
                $this.on('click', '.badge-flip', function(e) {
                    var badgeID = $this.attr("data-badge-id");
                    $this.toggleClass("is-flipped");
                    if( $this.hasClass("is-flipped") ){
                        $this.badgeCardDetails(options);
                    }
                }); // done set on click
            }); // done return
        }
    });

    $(document).ready(function(){
        //$('.badge').badgeCard();
    });

})(jQuery);
